<div (click)="goToPage.emit()" class="option">
  @if(icon) { <img alt="" class="arabic-transform" src="assets/imgs/menu/{{icon}}" /> }
  {{ title }}

  <ng-content select="[slot=content]"></ng-content>
</div>
